(function () {
    "use strict";

    angular
        .module("app")
        .directive("countryOfOriginTypeAhead", ["PrototypeService", countryOfOriginTypeAhead]);

    function countryOfOriginTypeAhead(prototypeService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return prototypeService.getCountries(searchText).then(function (response) {
                        if (response) {
                            return response;
                        }
                        return [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.CountryKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "="},
            template: '<input' +
                ' uib-typeahead="item.CountryKey for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();

